import { NgModule } from '@angular/core';
import { MaterialModule } from '@alfresco/adf-core';
import { NgxMatFileInputModule } from '@angular-material-components/file-input';
import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';

@NgModule({
  imports: [
    MaterialModule,
    NgxMatFileInputModule, 
    MatChipsModule, 
    MatStepperModule, 
    DragDropModule, 
    MatButtonToggleModule, 
    MatFormFieldModule, 
    MatToolbarModule, 
    MatIconModule, 
    MatMenuModule, 
    MatButtonModule,
    MatTreeModule
  ],
  exports: [
    MaterialModule,
    NgxMatFileInputModule, 
    MatChipsModule, 
    MatStepperModule, 
    DragDropModule, 
    MatButtonToggleModule, 
    MatFormFieldModule, 
    MatToolbarModule, 
    MatIconModule, 
    MatMenuModule, 
    MatButtonModule,
    MatTreeModule
  ],
})
export class AldenMaterialModule {}
